<i-feather [name]="icon!" [class]="class"></i-feather>